import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Navbar from "../../../../Components/Navbar";
import { EmployeeDetailsSc } from "./index.sc";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../../hooks";

import { getEmployeeMasterDetails } from "../../../../api/HRDashboard/getIndividualEmployeeDetails";
function Index() {
  const params = useParams();
  const auth = useAuthContext();
  const [userDetail, setUserDetail] = useState<any>([]);
  const fetchEmployeeDetails = async () => {
    await getEmployeeMasterDetails(
      auth?.userInfo?.orgs[0]?.id,
      params?.employeeId
    )
      .then((e) => {
        console.log(e);
        setUserDetail(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchEmployeeDetails();
  }, []);
  return (
    <EmployeeDetailsSc>
      <div className="downloadModal">
        <Button>Download</Button>
      </div>
      {userDetail?.map((data: any) => {
        return (
          <>
            <div className="table-details">
              <label>Personal Details:</label>

              <table>
                <tr>
                  <th className="heading">Employee Id</th>
                  <th className="heading">Name</th>
                  <th className="heading">Personal Email</th>
                  <th className="heading">Date Of Birth</th>
                  <th className="heading">PassPort Number</th>
                  <th className="heading">Address</th>
                </tr>
                <tr>
                  <td>{data?.employee_id}</td>
                  <td>{data?.Name}</td>
                  <td>{data?.p_mail}</td>
                  <td>{data?.dob}</td>
                  <td>{data?.passport_no}</td>
                  <td>{}</td>
                </tr>
              </table>
            </div>

            <div>
              <label>Employee Account Details:</label>
              <table>
                <tr>
                  <th className="heading">Account Number</th>
                  <th className="heading">PAN number</th>
                  <th className="heading">Aadhar number</th>
                  {/* <th className="heading">Nominees Name</th>
              <th className="heading">Nominees Relationship</th>
              <th className="heading">Nominees Proof Details</th>
              <th className="heading">Nominees Proof Number</th> */}
                </tr>
                <tr>
                  <td>{data?.acc_no}</td>
                  <td>{data?.pan_no}</td>
                  <td>{data?.aadhar_no}</td>
                  {/* <td>{data?.}</td>
              <td>Th</td>
              <td>Th</td>
              <td>Th</td> */}
                </tr>
              </table>
            </div>
            <div>
              <label>Official Details:</label>
              <table>
                <tr>
                  <th className="heading">Offcial Email</th>
                  <th className="heading">Date Of Join</th>
                  {/* <th className="heading">System Model</th>
              <th className="heading">System Number</th> */}
                </tr>
                <tr>
                  <td>{data?.c_mail}</td>
                  <td>{data?.doj}</td>
                  {/* <td>{data?.}</td>
              <td>Th</td> */}
                </tr>
              </table>
            </div>
          </>
        );
      })}
    </EmployeeDetailsSc>
  );
}

export default Index;
